<template>
  <el-dialog :visible.sync="visible" v-if="visible" width="45%" :close-on-click-modal="false">
    <template #title>
      <h1 class="title" style="border-left: solid 7px; padding-left: 15px;">
        {{ title }}
      </h1>
    </template>

    <slot>
      Content
    </slot>

    <template #footer>
      <div
        v-if="showFooter"
        style="display: flex; justify-content: space-between;"
      >
        <button
          class="btn btn-form btn-gray btn-footer"
          @click="setVisible(false)"
          style="margin: 0px;"
        >
          Cancel
        </button>
        <slot name="footer-btn">
          <el-button
            class="btn btn-form btn-footer"
            :class="btnColor ? btnColor : 'btn-blue'"
            @click="setVisible(false)"
            :disabled="btnDisabled"
          >
            Confirm
          </el-button>
        </slot>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    title: String,
    btnColor: String,
    btnDisabled: Boolean,
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.isDialogVisible;
      },
      set(value) {
        this.setVisible(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setVisible: "setDialogVisible",
    }),
  },
};
</script>
<style lang="sass" scoped>
h1
    padding-bottom: 0px
</style>
